export function getLocalStoreName() {
    if (typeof window === 'undefined') {
        return '';
    }
    const marketPath = window.stockcarsMarketPath ? window.stockcarsMarketPath : '';
    const startPage = window.stockcarsScsStartPage
        ? window.stockcarsScsStartPage
        : '';
    return `VTP_${marketPath}_${startPage}`;
}
export function getFilterPresetHash(store) {
    if (store) {
        const storeObj = JSON.parse(store);
        const { filterParams } = storeObj;
        if (filterParams) {
            const activeFilters = filterParams.filter
                .map((filterDTO) => filterDTO.toString())
                .join(',');
            const activePresets = filterParams.preset
                .map((filterDTO) => filterDTO.toString())
                .join(',');
            const filterString = `filter=${activeFilters}`;
            const presetsString = `preset=${activePresets}`;
            return `#${activeFilters ? filterString : ''}${activeFilters && activePresets ? '&' : ''}${activePresets ? presetsString : ''}`;
        }
    }
    return '';
}
function getLocalStore() {
    if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {
        const storeName = getLocalStoreName();
        return localStorage && localStorage.getItem(storeName);
    }
    return undefined;
}
export function readFilterFromLocalStore() {
    const store = getLocalStore();
    if (store) {
        return getFilterPresetHash(store);
    }
    return '';
}
export function getSearchInfoForTracking() {
    const searchInfo = {
        filterArray: [],
        sortingOption: '',
        totalCount: 0,
    };
    const store = getLocalStore();
    if (store) {
        const storeObj = JSON.parse(store);
        const { filterParams, sorting, totalCount } = storeObj;
        searchInfo.sortingOption = sorting.results;
        searchInfo.totalCount = totalCount;
        if (filterParams) {
            const activeFilters = filterParams.filter;
            activeFilters.forEach((value) => {
                if (value.indexOf(':') !== -1) {
                    const splitValue = value.split(':');
                    if (splitValue.length === 2 && splitValue[1].indexOf('_') !== -1) {
                        const range = splitValue[1].split('_');
                        searchInfo.filterArray.push({ id: splitValue[0], values: [range[0], range[1]] });
                    }
                }
                else if (value.indexOf('.') !== -1) {
                    searchInfo.filterArray.push({ id: value, values: [] });
                }
            });
        }
    }
    return searchInfo;
}
